module.exports = __webpack_public_path__ + "media/images/front/icon_post-c07083357eecd0455b770de5e5d0d69a.png";